"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalJobAction = void 0;
var RenewalJobAction;
(function (RenewalJobAction) {
    RenewalJobAction["IMMINENT"] = "IMMINENT";
    RenewalJobAction["UPCOMING"] = "UPCOMING";
    RenewalJobAction["RENEW"] = "RENEW";
    RenewalJobAction["RETRY"] = "RETRY";
    RenewalJobAction["RESUME"] = "RESUME";
    RenewalJobAction["CANCEL"] = "CANCEL";
    RenewalJobAction["HOLD"] = "HOLD";
    RenewalJobAction["REJECT"] = "REJECT";
    RenewalJobAction["SKIP"] = "SKIP";
    RenewalJobAction["SKIP_PAUSED"] = "SKIP_PAUSED";
    RenewalJobAction["SKIP_RESUME"] = "SKIP_RESUME";
    RenewalJobAction["SKIP_RENEWAL"] = "SKIP_RENEWAL";
    RenewalJobAction["SKIP_RETRY"] = "SKIP_RETRY";
    RenewalJobAction["SKIP_DISPATCHING"] = "SKIP_DISPATCHING";
})(RenewalJobAction = exports.RenewalJobAction || (exports.RenewalJobAction = {}));
